/*
 * Filename: dynamic-source.controller.ts
 * Description: Component for dynamic source rule.
 */
import { IDynamicSourceJSON } from '../../IRules.interface';

export class CQDynamicSourceRuleController {

    public ruleJSON: IDynamicSourceJSON = {};

    constructor(ruleObject: any) {
        this.formRuleObject(ruleObject);
    }

    /**
     * @memberof CQDynamicSourceRuleController
     */
    private formRuleObject = (ruleObject: any) => {
        this.ruleJSON = {
            [ruleObject.objectName]: {
                DynamicSource:{
                    ns: ruleObject.DynamicSource.ns,
                    componentname: ruleObject.DynamicSource.componentname
                },
                LookupFilter:{
                    fields: ruleObject.LookupFilter
                }
                
            }
        }
        return this.ruleJSON
    }
}

